import { useApi } from '@/api';
import {
  ActivityCard,
  EntityName,
  KpiCard,
  Page,
  PageSkeleton
} from '@/components';
import { CryptoIcon, Flex, Heading } from '@blockanalitica/ui';
import { useParams } from 'react-router-dom';
import HistoricTabs from './HistoricTabs';

export default function KeelIlkPage() {
  const { ilk } = useParams();
  const [data, error] = useApi({
    url: `/groups/keel/ilks/${ilk}/`,
    queryParams: {
      days_ago: 1
    }
  });

  if (error) {
    throw error;
  }

  if (data) {
    return (
      <Page
        title={
          <EntityName
            symbol1={
              <CryptoIcon
                name={data.collateral_symbol}
                address={data.collateral_address}
                size="6"
              />
            }>
            <Flex gap="3xs" flexDirection="column">
              <Flex gap="3xs">
                <Heading size="1">{data.name}</Heading>
              </Flex>
              <Flex gap="3xs" color="muted">
                {data.ilk}
              </Flex>
            </Flex>
          </EntityName>
        }>
        <Flex gap={['m', 's']} flexDirection={['column', 'row']}>
          <KpiCard
            title="Total Debt"
            variant="dai"
            data={data}
            field="debt"
            options={{
              valueOptions: {
                currencyValueOptions: {
                  currency: 'DAI'
                }
              }
            }}
          />
        </Flex>

        <HistoricTabs ilk={ilk} />

        <ActivityCard
          url={`/groups/keel/ilks/${ilk}/activity/`}
          linkTo="activity"
        />
      </Page>
    );
  }
  return <PageSkeleton />;
}
